<template>
    <b-card class="shadow mb-5 ml-md-5 mr-md-5 ml-0 mr-0 p-3">
        <div class="pt-3">
            <div class="d-flex flex-column flex-sm-row justify-content-center align-items-center"  v-if="!failedLoading">
                <span class="mr-3 mb-3"><b-spinner variant="secondary" /></span>
                <span class="h4 text-secondary mb-3 pb-0 text-center">Загружается...</span>
            </div>
            <div class="d-flex flex-column flex-sm-row justify-content-center align-items-center text-secondary h4" v-else >
                <span  class="mr-3 mb-3"><b-icon icon="emoji-frown"/></span>
                <span class="text-center mb-3">Ошибка загрузки</span>
            </div>
        </div>
    </b-card>
</template>

<script>
export default {
    name: "Stub",
    props: {
        failedLoading: { type: Boolean, default: false }
    }
}
</script>

<style scoped>

</style>